/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Cc_All_TitleInputs */



/**
* | output |
* | --- |
* | "Mark All As CC" |
*
* @param {Iconik_Publish_Cc_All_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_cc_all_title = /** @type {((inputs?: Iconik_Publish_Cc_All_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Cc_All_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Marquer tout comme CC")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle als CC markieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Segna tutto come CC")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отметить все как CC")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marcar todo como CC")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("全部标记为 CC")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべてをCCとしてマーク")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी को CC के रूप में चिह्नित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Marcar tudo como CC")
	return /** @type {LocalizedString} */ ("Mark All As CC")
});